import React, { useEffect, useState } from "react"
import { getAllLoans } from "services/LoanService"
import AppLoansComp from "./ApprovedLoans"
import DisLoansComp from "./DisbursedLoans"
import RejLoansComp from "./RejectedLoans"
import TabHeader from "../TabHeader"
import { useSearchParams } from "react-router-dom"
// import AcceptedLoans from "./AcceptedLoans"

const Tabs = () => {
	const [loans, setLoans] = useState([])
	const [toggleState, setToggleState] = useState(1)

	const [params, setParams] = useSearchParams()

	const handleSetTab = (tab) => {
		setParams({ tab })
		setToggleState(tab)
	}

	useEffect(() => {
		const currentTab = params.get("tab")
		if (currentTab) {
			setToggleState(parseInt(currentTab))
		}
	}, [params])

	const fetchAllLoans = async () => {
		const result = await getAllLoans()

		setLoans(result?.data)
		return result?.data
	}
	useEffect(() => {
		fetchAllLoans()
	}, [loans])

	const tabs = [
		{ label: "Approved", index: 1 },
		{ label: "Rejected", index: 2 },
		{ label: "Disbursed", index: 3 },
	]

	return (
		<div>
			<TabHeader
				currentTab={toggleState}
				selectTab={handleSetTab}
				tabs={tabs}
			/>
			<div className="p-4">
				{toggleState === 1 && (<AppLoansComp />)}
				{toggleState === 2 && (<RejLoansComp />)}
				{toggleState === 3 && (<DisLoansComp />)}
			</div>
		</div>
	)
}

export default Tabs